import { Box, Chip } from '@mui/material';

type Props = {
  tags?: string[];
};

const Tags = ({ tags }: Props) => {
  if (!tags || !tags.length) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
      }}
    >
      {tags?.map((category, index) => {
        const isLast = tags!.length - 1 === index;
        return (
          <Chip
            key={category}
            label={category}
            size={'small'}
            color={'secondary'}
            sx={{ mr: isLast ? 0 : 1, mb: 1, borderRadius: 0.5 }}
          />
        );
      })}
    </Box>
  );
};

export default Tags;
